export type OpacityType =
  | 'OPACITY_UNKNOWN'
  | 'OPACITY_NONE'
  | 'OPACITY_3'
  | 'OPACITY_5'
  | 'OPACITY_20'
  | 'OPACITY_30'
  | 'OPACITY_40'
  | 'OPACITY_50'
  | 'OPACITY_100';

export enum Opacity {
  OPACITY_UNKNOWN = 'OPACITY_UNKNOWN',
  OPACITY_NONE = 'OPACITY_NONE',
  OPACITY_3 = 'OPACITY_3',
  OPACITY_5 = 'OPACITY_5',
  OPACITY_20 = 'OPACITY_20',
  OPACITY_30 = 'OPACITY_30',
  OPACITY_40 = 'OPACITY_40',
  OPACITY_50 = 'OPACITY_50',
  OPACITY_100 = 'OPACITY_100',
}
